import { render } from "./TeamRosterSunC.vue?vue&type=template&id=7c35d9dc&scoped=true"
import script from "./TeamRosterSunC.vue?vue&type=script&scoped=true&lang=js"
export * from "./TeamRosterSunC.vue?vue&type=script&scoped=true&lang=js"

import "./TeamRosterSunC.vue?vue&type=style&index=0&id=7c35d9dc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c35d9dc"]])

export default __exports__